import Typography from '@mui/material/Typography'
import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { SourceEntity } from 'types/SourceEntity'
import { EditSourceDialog } from './AdminEditSourceDialog'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Stack from '@mui/material/Stack'
import { formatDateYYYYMMDDhhmm } from '../../../../packages/utils/numberFormatters'
import Button from '@mui/material/Button'
import { SourceForm } from '../../types/SourceForm'
import { PressReleaseApi } from '../../../../api/PressReleasesApi'
import { useForm } from 'react-hook-form'
import { SourceUrl } from './AdminSourceUrl'
import { IssueType, PressReleaseLight, TransactionType } from '@finance-lab/utils/types'

const pressReleaseApi = new PressReleaseApi()

export const SourceInternalTableRow = ({
    issueType,
    onDelete,
    onUpdate,
    source,
    transactionType,
    duplicateSources = {},
}: {
    issueType: IssueType | null
    onDelete: (s: Pick<SourceEntity, 'prId'>) => void
    onUpdate: (s: SourceForm) => boolean
    source: Extract<SourceForm, { prId: string }>
    transactionType: TransactionType
    duplicateSources: Record<string, boolean>
}) => {
    const [openEditDialog, setOpenEditDialog] = useState(false)
    const [pressRelease, setPressRelease] = useState<Pick<PressReleaseLight, 'title' | 'publishedAt'> | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const formMethods = useForm()
    const handleDelete = (source: Pick<SourceEntity, 'prId'>) => {
        onDelete(source)
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (source.prId) {
                    const result = await pressReleaseApi.findById(source.prId)

                    setPressRelease(result)
                }
            } finally {
                setIsLoading(false)
            }
        }

        void fetchData()
    }, [source.prId])

    return (
        <React.Fragment>
            {createPortal(
                <EditSourceDialog
                    open={openEditDialog}
                    setOpen={setOpenEditDialog}
                    source={source}
                    issueType={issueType}
                    transactionType={transactionType}
                    sources={formMethods.watch('sources')}
                    onUpdate={onUpdate}
                />,
                document.body,
            )}
            <TableRow>
                <TableCell>
                    <Stack>
                        <SourceUrl source={source} />
                        {duplicateSources[source.prId] && (
                            <Typography variant='caption' sx={{ color: 'red' }}>
                                Registrerad tidigare
                            </Typography>
                        )}
                    </Stack>
                </TableCell>
                <TableCell>{source.internalComment}</TableCell>
                <TableCell>{source.sourceType}</TableCell>
                <TableCell>{isLoading ? 'Hämtar data...' : (pressRelease?.title ?? 'Titel saknas')}</TableCell>
                <TableCell>
                    {pressRelease?.publishedAt
                        ? formatDateYYYYMMDDhhmm(pressRelease.publishedAt)
                        : !pressRelease && source.publishedDate
                          ? formatDateYYYYMMDDhhmm(source.publishedDate)
                          : ''}
                </TableCell>
                <TableCell>
                    <Stack spacing={1}>
                        <Button variant='outlined' onClick={() => setOpenEditDialog(true)}>
                            Redigera
                        </Button>
                        <Button variant='text' onClick={() => handleDelete(source)}>
                            [Ta&nbsp;bort]
                        </Button>
                    </Stack>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}
